var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconsPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5970279,
    cx: 35.4863,
    cy: 35.6047,
    r: 34.5,
    stroke: "white",
    fillOpacity: 0.20648,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4238 30.6435L44.7118 33.2365L42.3538 32.1745L41.6158 34.3705L44.1538 34.9295L42.4258 36.8375L44.2978 38.2065L45.6128 35.9915L46.9088 38.2065L48.7818 36.8375L47.0528 34.9295L49.5918 34.3705L48.8718 32.1745L46.5128 33.2365L46.7828 30.6435H44.4238ZM35.0578 30.6435L35.3458 33.2365L32.9878 32.1745L32.2498 34.3705L34.7878 34.9295L33.0598 36.8375L34.9318 38.2065L36.2468 35.9915L37.5428 38.2065L39.4158 36.8375L37.6868 34.9295L40.2248 34.3705L39.5048 32.1745L37.1468 33.2365L37.4168 30.6435H35.0578ZM25.6918 30.6435L25.9798 33.2365L23.6218 32.1745L22.8828 34.3705L25.4218 34.9295L23.6928 36.8375L25.5658 38.2065L26.8798 35.9915L28.1768 38.2065L30.0488 36.8375L28.3208 34.9295L30.8598 34.3705L30.1398 32.1745L27.7808 33.2365L28.0508 30.6435H25.6918Z",
    id: "mask-fill-icon"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconsPassword);
export default __webpack_public_path__ + "static/media/profile_icons_password.2cbd059a5661a6b3dae28f9c30662f4c.svg";
export { ForwardRef as ReactComponent };